import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import HTMLReactParser from "html-react-parser";
import PropertyTypeCard from "../PropertyTypeCard/PropertyTypeCard";
import "./LandingPage.scss";
import { Link } from "gatsby";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router"
import SiteLogo from "../../images/logo.svg";
const LandingPage = (props) => {

    let titleText = "";
    if(props?.data?.Title) {
        titleText = props?.data?.Title.replace(props?.data?.Italic_Text, `<em>${props?.data?.Italic_Text}</em>`);
        titleText = HTMLReactParser(titleText)
    }
    let ctaText = '';
    let ctaHref = '';
    
    if (typeof window !== 'undefined') {
        const currentURL = window.location.href;

        if (currentURL.includes('/block-management/')) {
            ctaText = 'Contact Block Management';
            ctaHref = '/contact/block-management/';
        } else if (currentURL.includes('/property-management/')) {
            ctaText = 'Contact Property Management';
            ctaHref = '/contact/property-management/';
        }
        
    }
      var { pathname } = useLocation()
      var pageUrl = process.env.GATSBY_SITE_URL + pathname
    const showBlockManagementCTA = typeof window !== 'undefined' && window.location.href.includes('block-management');
    const formattedDescription = props?.data?.Description?.replace(/\n/g, '<br />');
    const totalLimit = props?.modules?.some(
        c => Array.isArray(c.Links_with_Media_Data) && c.Links_with_Media_Data.length < 4
    );
    return (
        <div className="landing-page">
            <Helmet>
                <meta name="robots" content="index, follow" />
                 {props?.data?.CSS_Class === "renters-rights-bill" &&
               
                    <script type="application/ld+json">{`{
                            "@context": "https://schema.org", 
                            "@type": "WebPage", 
                            "name": "${props?.data?.Title}", 
                            "url": "${pageUrl}", 
                            "description": "${props?.data?.Meta_Description}", 
                            "inLanguage": "en", 
                            "publisher": { 
                                "@type": "Organization", 
                                "name": "tlc Estate Agents", 
                                "logo": { 
                                    "@type": "ImageObject", 
                                    "url": "${SiteLogo}"
                                } 
                             }             
                            }`}
                    </script>
            }
            </Helmet>
            <section className="heading-block">
                <Container>
                    <Row>
                        <Col>
                        <h1 className="h2">{titleText}</h1>
                            <div className="question-wrap">{HTMLReactParser(formattedDescription)}
                                {ctaText && ctaHref && (
                                    <p><a href={ctaHref} className="btn contact-block-cta">
                                        {ctaText}
                                    </a></p>
                                )}
                            </div>
                            
                            <div className={`property-type_wrap ${totalLimit ? "limited-cards" : ""}`}>
                                {props?.modules?.filter(c => Array.isArray(c.Links_with_Media_Data) && c.Links_with_Media_Data.length > 0).length > 0 &&
                                    <PropertyTypeCard 
                                        data={props?.modules?.filter(c => Array.isArray(c.Links_with_Media_Data) && c.Links_with_Media_Data.length > 0)[0]?.Links_with_Media_Data}
                                    />
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}

export default LandingPage;
